module.exports = __webpack_public_path__ + "static/assets/eab0731f7f236b126bc5140614953685.svg";